import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { HttpEventType } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ticket-raised-model',
  templateUrl: './ticket-raised-model.component.html',
  styleUrls: ['./ticket-raised-model.component.scss'],
})
export class TicketRaisedModelComponent {
  ticketForm: FormGroup;
  selectedFiles: File[] = [];
  uploadProgress: number | null = null;
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<TicketRaisedModelComponent>,
    private fb: FormBuilder,
    private api: ApiServiceService,
    public toastr:ToastrService
  ) {
    this.ticketForm = this.fb.group({
      subject: ['', Validators.required],
      description: ['', Validators.required],
      callbackNumber: ['', Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onFileSelected(event: any): void {
    this.selectedFiles = Array.from(event.target.files);
  }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  onSubmit(): void {
    if (this.ticketForm.invalid || this.selectedFiles.length === 0) {
      this.errorMessage = 'Please fill all fields and select files.';
      return;
    }

    const formData = new FormData();
    formData.append('subject', this.ticketForm.value.subject);
    formData.append('description', this.ticketForm.value.description);
    formData.append('callbackNumber', this.ticketForm.value.callbackNumber);

   // Append the user ID as a separate field
  const userId = this.getCurrentUserId();
  formData.append('userId', userId); // Add userId as a separate field

    // Append files to FormData
    this.selectedFiles.forEach((file) => {
      formData.append('files', file);
    });


    this.api.raiseTicket(formData).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          this.successMessage = 'Ticket raised successfully!';
          this.toastr.success('Ticket raised successfully!', 'Success'); // Show success toast
          this.errorMessage = null;
          this.ticketForm.reset();
          this.selectedFiles = [];
          this.uploadProgress = null;
        }
      },
      (error) => {
        this.errorMessage = 'Failed to raise ticket. Please try again.';
        this.toastr.error('Failed to raise ticket. Please try again.', 'Error'); // Show error toast
        this.successMessage = null;
        console.error('Error raising ticket:', error);
      }
    );
  }
  }